import { useContext } from "react";

import { LureContext } from "../contexts/lureContext";

const useLuresProvider = () => useContext(LureContext)

export default useLuresProvider;